import { render } from "./ServicesPage.vue?vue&type=template&id=b80354f2"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
script.render = render

export default script